/**
 * Whether this page load is the invitation editor's preview (/preview).
 *
 * Read at module load by what has to stay quiet there — the i18n language
 * cache and main.jsx's consent / attribution start-up — so it cannot wait for
 * the router. index.html's GTM loader repeats the same test inline (it runs
 * before any bundle can); keep the two in step.
 *
 * It matches every URL React Router sends to the Preview page (routes match
 * case-insensitively, with or without a trailing slash), so nothing that page
 * draws ever loads tags or caches a language. vercel.json is stricter the
 * other way round: only the exact `/preview` path may be framed.
 */
export const isPreviewPath = (pathname = globalThis.location?.pathname ?? "") =>
  /^\/preview\/?$/i.test(pathname);
